import { ProfilePageTypes } from "enums/ProfilePageTypes";
import { useEffect } from "react";
import { Analytics } from "services/Analytics/Analytics";
import type { IServices } from "services/IServices";

const useInitAnalytics = (services: IServices) =>
    useEffect(
        () => {
            Analytics.init(
                ProfilePageTypes.USER_PROFILE,
                services.AuthApiClient,
                services.TiendeoStatsClient,
            );
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

export default useInitAnalytics;
